import { isObject } from 'lodash'
import moment from 'moment'
import Decorator from './decorator'

export default class TermDecorator extends Decorator {
  exists () {
    return isObject(this.decorated) && this.decorated.id !== null
  }

  formattedPublishedAt () {
    if (this.decorated.published_at) {
      return moment(this.decorated.published_at, 'YYYY-MM-DD HH:mm:ss')
        .format('DD/MM/YYYY, h:mm a')
    }

    return '–'
  }

  publishedBy () {
    if (isObject(this.decorated.publisher)) {
      return this.decorated.publisher.email
    }

    return '–'
  }

  statusText () {
    if (this.isArchived) {
      return 'Archived'
    } else if (this.isDraft) {
      return 'Draft'
    } else if (this.isPublished) {
      return 'Published'
    }
  }

  isDraft () {
    return this.decorated.status === 1
  }

  isPublished () {
    return this.decorated.status === 2
  }

  isArchived () {
    return this.decorated.status === 0
  }

  isNotPublished () {
    return this.decorated.status !== 2
  }
}



// WEBPACK FOOTER //
// ./src/decorators/terms.js